<template>
  <div>
    <div
      :class="{
        'queue-card-wrapper': true,
        'card-no-buttons': !shouldShowActions,
      }"
    >
      <div :class="headerClass">
        <div class="header-info">
           <HeaderCheque :mode="'TAKEAWAY'" :chequeId="preorder.local_id" />
           

          <ClientName
            :class="clientNameClass"
            v-if="preorder.client"
            :systemColor="preorder.status != 'cancelled' ? yellow : 'white'"
            :clientName="clientNameValue"
          />

          <div class="cheque-list-details" v-if="preorder.client">
            
              <div class="cheque-detail-item" v-if="preorder.client.phone">
                <img
                  :src="
                    uiWhiteIcons
                      ? '/icons/mobile-white.svg'
                      : '/icons/mobile.svg'
                  "
                />
                <!-- <p class="order-info">{{$t('preorder_card.phone')}}</p> -->

                <p class="client-phone-value" @click="callPhone">
                  {{ clientPhoneValue }}
                </p>
              </div>

              <div class="cheque-detail-item" v-if="shouldShowDeliveryTime">
                <img
                  :src="
                    uiWhiteIcons ? '/icons/time-white.svg' : '/icons/time.svg'
                  "
                />
                <!-- <p class="order-info">{{ $t('preorder_card.serve_date') }}</p> -->
                <p>
                  {{ serveDateTimeString }}
                  <span class="serving-timer" v-if="serving_time >= 0">
                    ({{ $t("preorder_card.serve_plus") }} {{ serving_time }}
                    {{ $t("waiting.time") }})
                  </span>
                  <span
                    class="serving-timer serving-timer-red"
                    v-if="serving_time < 0"
                  >
                    ({{ -serving_time }} {{ $t("waiting.time") }}
                    {{ $t("preorder_card.serve_minus") }})
                  </span>
                </p>
              </div>
              <div class="cheque-detail-item" v-if="!shouldShowDeliveryTime && preorder.takeaway_date">
                <img
                  :src="
                    uiWhiteIcons ? '/icons/time-white.svg' : '/icons/time.svg'
                  "
                  class="takeaway-icon"
                />
                <!-- <p class="order-info takeaway-order-info">{{ $t('preorder_card.takeaway') }}</p> -->
                <p>{{ takeawayDateTimeString }}</p>
              </div>
              <div class="cheque-detail-item" v-if="!shouldShowDeliveryTime && !preorder.takeaway_date">
                <img
                  :src="
                    uiWhiteIcons ? '/icons/time-white.svg' : '/icons/time.svg'
                  "
                />
                <!-- <p class="order-info">{{ $t('preorder_card.time') }}</p> -->
                <p>{{ preorderTimeString }}</p>
              </div>
              <div class="cheque-detail-item">
                <img
                  :src="
                    uiWhiteIcons ? '/icons/date-white.svg' : '/icons/date.svg'
                  "
                />
                <!-- <p class="order-info">{{ $t('preorder_card.date') }}</p> -->
                <p>{{ takeawayDateString }}</p>
              </div>
              <div class="cheque-detail-item" v-if="preorder.guests_count !== undefined">
                <img
                  :src="
                    uiWhiteIcons
                      ? '/icons/guests-white.svg'
                      : '/icons/guests.svg'
                  "
                />
                <!-- <p class="order-info">{{$t('preorder_card.phone')}}</p> -->

                <p>
                  {{ preorder.guests_count }}
                  {{ $tc("units.guests", preorder.guests_count) }}
                </p>
              </div>
              <div class="cheque-detail-item" v-if="preorder.pay_method">
                <img
                  :src="
                    uiWhiteIcons
                      ? '/icons/payment-white.svg'
                      : '/icons/payment.svg'
                  "
                />
                <!-- <p class="order-info">{{$t('preorder_card.phone')}}</p> -->

                <p>
                  {{
                    $t(`card.pay_methods.${preorder.pay_method || "online"}`)
                  }}
                </p>
              </div>
              <div class="cheque-detail-item" v-if="preorder.with_reservation">
                <img :src="'/icons/reservation.svg'" />
                <!-- <p class="order-info">{{$t('preorder_card.phone')}}</p> -->

                <p>{{ $t(`preorder_card.with_reservation`) }}</p>
              </div>
              <div class="cheque-detail-item" v-else>
                <img :src="uiWhiteIcons ? '/icons/takeaway-white.svg' : '/icons/takeaway.svg'" />
                <!-- <p class="order-info">{{$t('preorder_card.phone')}}</p> -->

                <p>{{ $t(`preorder_card.with_takeaway`) }}</p>
              </div>
              <div
                class="cheque-detail-item"
                v-if="preorder.is_delivery"
              >
                <img
                  :src="
                    uiWhiteIcons
                      ? '/icons/address-white.svg'
                      : '/icons/home.svg'
                  "
                />
                <!-- <p class="order-info">{{$t('preorder_card.address')}}</p> -->
                <p class="address">{{ preorder.client.address }}</p>
              </div>
             
          </div>
          <PreorderStatusBar :preorder="preorder" />
        </div>
      </div>

      <div class="preorder-card-body">
        <div class="preorder-card-list">
          <ItemList
            :list="preorder.list"
            :mode="
              preorder.status == 'editing' || preorder.status == 'creating'
                ? 'edit'
                : 'view'
            "
            :new_preorder="!preorder._id"
            @changeQuantity="emitChangeQuantity"
          />
        </div>

        <div class="total-block">
          <h4 class="total">{{ $t("card.total") }}</h4>
          <span class="amount">{{ orderTotal }}{{ currency.symbol }}</span>
        </div>

        <div class="comment" v-if="preorder.discount">
          <h6 class="color-grey">{{ $t("card.discount") }}</h6>
          <p>{{ preorder.discount }}%</p>
        </div>

        <div class="comment" v-if="preorder.comment">
          <h6 class="color-grey">{{ $t("card.comment") }}</h6>
          <p>{{ preorder.comment }}</p>
        </div>

        <div
          class="comment"
          v-if="preorder.reason && preorder.status == 'cancelled'"
        >
          <h6 class="color-grey">{{ $t("card.reason") }}</h6>
          <p class="color-red">{{ preorder.reason }}</p>
        </div>

        <div class="comment color-green" v-if="preorder.paid_by_bonuses">
          <h6>{{ $t("preorder_card.paid_by_bonuses") }}</h6>
        </div>

        <!-- <div class="pay-method pay-method-first">
          <div class="color-grey">{{ $t('card.pay_method') }}</div>
          <div v-if="preorder.paid_by_bonuses">{{ $t(`card.pay_methods.bonus`) }}</div>
          <div v-else>{{ $t(`card.pay_methods.${preorder.pay_method || 'online'}`) }}</div>
        </div>

        <div class="pay-method">
          <div class="color-grey">{{ $t('card.pay_status') }}</div>
          <div>
            <span
              class="color-green"
              v-if="!preorder.pay_method || preorder.pay_method == 'online' || preorder.status == 'closed'"
            >{{ $t('card.paid')}}</span>
            <span class="color-red" v-else>{{ $t('card.unpaid' )}}</span>
          </div>
        </div>-->

        <!-- <div class="choose-delivery-time" v-if="actionsUiState === 'accept'">
          <h5>{{$t('waiting.title')}}:</h5>
          <div class="delivery-time-buttons">
            <div :class="getTimeBadgeClass(20)" @click="setWaitingTime(20)">
              20 {{ $t("waiting.time") }}
            </div>
            <div :class="getTimeBadgeClass(30)" @click="setWaitingTime(30)">
              30 {{ $t("waiting.time") }}
            </div>
            <div :class="getTimeBadgeClass(40)" @click="setWaitingTime(40)">
              40 {{ $t("waiting.time") }}
            </div>
          </div>
          <input
            class="delivery-time-input"
            type="number"
            pattern="[0-9]*"
            v-model.number="waiting_time"
            placeholder="Вказати точний час"
            min="15"
            max="3600"
          />
        </div>-->
        <div class="order-actions-box pb-20" v-if="actionsUiState === 'accept' && preorder.pay_method != 'online'">
          <QueueButton
            @click="showEditUI"
            variant="light-outline"
            class="w-100"
            >{{ $t("preorder_card.action_edit") }}</QueueButton
          >
        </div>

        <AcceptTimeControls
          v-model="waiting_time"
          :times="suggestedWaitingTimes"
          v-if="
            actionsUiState == 'accept' ||
            (actionsUiState == 'edit' && !preorder._id)
          "
        />

        <small class="info" v-if="actionsUiState === 'accept'">{{
          $t("preorder_card.wait_limit")
        }}</small>

        <div v-if="actionsUiState === 'accept'" class="order-actions-box">
          <QueueButton
            class="action-cancel-button"
            variant="cancel"
            @click="emitCancel"
            :disabled="busy"
          >
            <img src="/icons/del.svg" class="del" />
          </QueueButton>
          <QueueButton
            @click="emitAccept"
            class="w-100"
            variant="accept"
            :busy="busy"
            :disabled="!waiting_time || busy"
            >{{ $t("actions.preorder_accept") }}</QueueButton
          >
        </div>

        <div class="choose-car-time" v-if="actionsUiState === 'car'">
          <h5>{{ $t("delivery_order_car.title") }}</h5>
          <div class="car-time-buttons">
            <div
              :class="getCarTimeBadgeClass(15)"
              @click="setCarWaitingTime(15)"
            >
              15 {{ $t("waiting.time") }}
            </div>
            <div
              :class="getCarTimeBadgeClass(20)"
              @click="setCarWaitingTime(20)"
            >
              20 {{ $t("waiting.time") }}
            </div>
            <div
              :class="getCarTimeBadgeClass(30)"
              @click="setCarWaitingTime(30)"
            >
              30 {{ $t("waiting.time") }}
            </div>
          </div>
        </div>

        <!-- <div class="preorder-card-actions" v-if="actionsUiState == 'accept' && canShowAccept">
        
          <QueueButton class="preorder-cancel-button" variant="cancel" @click="emitCancel">
            <img src="/icons/del.svg" />
          </QueueButton>
          <QueueButton
            @click="emitAccept"
            class="w-80"
            variant="accept"
          >{{ $t('actions.preorder_accept') }}</QueueButton>
        </div>-->

        <div class="order-actions-box" v-if="actionsUiState == 'send'">
          <QueueButton
            @click="emitToInside"
            variant="light-outline"
            class="w-100"
            v-if="actionsUiState === 'send' && canConvertToInside"
            >{{ $t("actions.to_inside") }}</QueueButton
          >
        </div>

        <div class="order-actions-box pb-0" v-if="actionsUiState == 'send'">
          <QueueButton
            class="action-cancel-button"
            variant="cancel"
            @click="emitCancel"
            :disabled="busy"
          >
            <img src="/icons/del.svg" class="del" />
          </QueueButton>
          <QueueButton
            @click="emitSend"
            class="w-100"
            variant="accept"
            :disabled="busy"
            :busy="busy"
            v-if="actionsUiState === 'send' && preorder.is_delivery"
            >{{ $t("actions.preorder_sent") }}</QueueButton
          >

          <QueueButton
            @click="emitSend"
            class="bg-preorder w-100"
            :disabled="busy"
            :busy="busy"
            v-if="actionsUiState === 'send' && !preorder.is_delivery"
            >{{ $t("actions.preorder_served") }}</QueueButton
          >
        </div>

        <div
          class="preorder-card-actions"
          v-if="actionsUiState == 'car' && canShowOrderCar"
        >
          <QueueButton @click="emitCarTime" class="w-100" variant="confirm">
            {{ $t("delivery_order_car.action") }}
          </QueueButton>
        </div>

        <div class="preorder-card-actions" v-if="actionsUiState == 'pay'">
          <QueueButton @click="emitClose" class="w-100" variant="dark">
            {{ $t("card.paid") }}
          </QueueButton>
        </div>
        <small class="info" v-if="actionsUiState == 'pay'">{{
          $t("preorder_card.preorder_autoclose")
        }}</small>
      </div>
    </div>

    <DeliveryDriver
      :driver="preorder.driver"
      v-if="preorder.driver && preorder.status == 'serving'"
    />
  </div>
</template>

<script>
import moment from "moment";
import HeaderCheque from "@/components/details/HeaderCheque.vue";
import QueueButton from "@/components/QueueButton.vue";
import ItemList from "@/components/item/ItemList.vue";
import ClientName from "@/components/ClientName.vue";
import PreorderStatusBar from "@/components/statusbar/PreorderStatusBar.vue";
import DeliveryDriver from "@/components/preorder/DeliveryDriver.vue";
// import OrderActions from '@/components/OrderActions.vue'
import AcceptTimeControls from "@/components/item/AcceptTimeControls.vue";

import OrderHelpers from "@/services/order/helpers.js";

export default {
  props: {
    preorder: Object,
  },
  data() {
    return {
      waiting_time: null,
      car_time: null,

      busy: false,

      serving_timer_id: null,
      serving_time: null,
      yellow: "preorder",
    };
  },
  mounted() {
    if (this.preorder.serve_date) {
      this.serving_timer_id = setInterval(this.tickServingTime, 30000);
      this.tickServingTime();
    }
  },
  watch: {
    waiting_time() {
      if (this.preorder.status == "editing") {
        this.$emit("setWaitingTime", this.waiting_time);
      }
    },
    'preorder.status'() {
      this.busy = false;
    }
  },
  beforeDestroy() {
    clearInterval(this.serving_timer_id);
  },
  methods: {
    emitAccept() {
      this.busy = true;
      this.$emit("accept", this.preorder._id, this.waiting_time);
    },
    emitClose() {
      this.busy = true;
      this.$emit("close", this.preorder._id);
    },
    emitSend() {
      this.busy = true;
      this.$emit("send", this.preorder._id);
    },
    emitCancel() {
      this.busy = true;
      this.$emit("cancel", this.preorder._id);
    },
    emitToInside() {
      this.$emit("to_inside", this.preorder._id);
    },
    emitCarTime() {
      this.$emit("car_time", this.preorder._id, this.car_time);
    },
    emitChangeQuantity(index, delta) {
      this.$emit("changeQuantity", index, delta);
    },
    setWaitingTime(time) {
      this.waiting_time = time;
    },
    setCarWaitingTime(time) {
      this.car_time = time;
    },
    getTimeBadgeClass(time) {
      return {
        "delivery-time-badge": true,
        "delivery-time-badge-active": this.waiting_time == time,
      };
    },
    getCarTimeBadgeClass(time) {
      return {
        "delivery-time-badge": true,
        "car-time-badge-active": this.car_time == time,
        "car-time-badge": true,
      };
    },
    tickServingTime() {
      const now = moment();
      const then = moment(this.preorder.serve_date);

      this.serving_time = then.diff(now, "minutes");
    },
    callPhone() {
      if (!this.preorder.cancelled_by_system)
        window.location.href = `tel:${this.preorder.client.phone}`;
    },
    showEditUI() {
      this.$router.push({
        name: "edit_preorder",
        params: {
          preorder_id: this.preorder._id,
        },
      });
    },
  },
  computed: {
    headerClass() {
      const suffix = this.preorder.is_delivery ? "delivery" : "preorder";
      return ["header", `header-${this.preorder.status}-${suffix}`];
    },
    isPaid() {
      if (!this.preorder.pay_method || this.preorder.pay_method == "online") {
        return true;
      }

      return this.preorder.status == "unpaid";
    },
    status() {
      if (this.preorder.status === "pending")
        return this.$t("card.status_paying");
      if (this.preorder.status === "confirmed")
        return this.$t("card.status_executed");

      return "???";
    },

    clientNameClass() {
      return {
        "client-confirmed-preorder": this.isPaid && !this.preorder.is_delivery,
        "client-confirmed-delivery": this.isPaid && this.preorder.is_delivery,
        "client-unpaid": this.preorder.status === "unpaid",
      };
    },
    takeawayDateTimeString() {
      return moment(this.preorder.takeaway_date).format("HH:mm");
    },
    serveDateTimeString() {
      return moment(this.preorder.serve_date).format("HH:mm");
    },
    takeawayDateString() {
      if (!this.preorder.takeaway_date) {
        return moment(this.preorder.confirmed_at).format("DD/MM/YY");
      }
      return moment(this.preorder.takeaway_date).format("DD/MM/YY");
    },
    preorderDateString() {
      return moment(this.preorder.created_at).format("DD.MM.YYYY");
    },
    preorderTimeString() {
      return moment(this.preorder.created_at).format("HH:mm");
    },
    shouldShowDeliveryTime() {
      return this.preorder.is_delivery && this.preorder.status == "serving";
    },
    actionsUiState() {
      //
      //This computed property determines what actions and inputs should be displayed
      //

      if (this.preorder.status == "confirmed") {
        return "accept";
      }

      if (this.preorder.status == "serving") {
        if (this.cafe.delivery.service_tag === "qrwaiter") {
          //qrwaiter deliveries allow only sending
          return "send";
        } else {
          return "send";
          // //if we are using partner delivery, ask for car
          // if (!this.preorder.car_ordered_at) {
          //   return "car";
          // } else {
          //   return "send";
          // }
        }
      }

      if (this.preorder.status == "unpaid") return "pay";

      if (
        this.preorder.status === "closed" ||
        this.preorder.status === "cancelled"
      ) {
        return "none";
      }

      if (this.preorder.status == "editing") {
        return "edit";
      }

      if (this.preorder.status == "creating") {
        return "create";
      }

      return "send";
    },
    shouldShowActions() {
      // if (this.preorder.status == "confirmed") {
      //   if (!this.waiting_time) return false;

      //   if (this.cafe.delivery.service_tag === 'qrwaiter') {
      //     return true;
      //   } else {
      //     return this.waiting_time >= 15;
      //   }
      // }

      // if (this.cafe.delivery.service_tag != 'qrwaiter') {
      //   return this.card
      //   return !!this.car_time;
      // }

      // return !!this.preorder.driver;
      // if (this.preorder.status == "confirmed") return !!this.waiting_time;
      // return true;

      if (this.preorder.status == "editing") return false;

      return (
        this.canShowAccept ||
        this.canShowOrderCar ||
        this.actionsUiState === "send" ||
        this.actionsUiState === "accept" ||
        this.actionsUiState == "pay"
      );
    },
    cafe() {
      return this.$store.state.cafe;
    },
    canShowAccept() {
      if (this.cafe.delivery.service_tag === "qrwaiter") {
        return !!this.waiting_time && !this.busy;
      } else {
        return !!this.waiting_time && this.waiting_time >= 15 && !this.busy;
      }
    },
    canShowOrderCar() {
      return this.car_time >= 15;
    },
    canConvertToInside() {
      return this.cafe.modes.inside;
    },
    uiWhiteIcons() {
      return (
        this.preorder.status == "closed" || this.preorder.status == "cancelled"
      );
    },
    currency() {
      return this.$store.state.currency;
    },
    orderTotal() {
      if (this.preorder.status != "editing")
        if (this.preorder._id || this.preorder.total) {
          return this.preorder.total;
        }

      return OrderHelpers.computeOrderTotal(this.preorder);
    },
    suggestedWaitingTimes() {
      return this.$store.state.waiting_times.preorder;
    },
    clientNameValue() {
      if (
        this.preorder.status == "cancelled" &&
        this.preorder.cancelled_by_system
      ) {
        return "".padStart(this.preorder.client.name.length, "*");
      } else {
        return this.preorder.client.name;
      }
    },
    clientPhoneValue() {
      if (
        this.preorder.status == "cancelled" &&
        this.preorder.cancelled_by_system
      ) {
        return (
          this.preorder.client.phone.substring(0, 3) +
          this.preorder.client.phone.substring(3).replace(/./g, "*")
        );
      } else {
        return this.preorder.client.phone;
      }
    },
  },
  components: {
    HeaderCheque,
    QueueButton,
    ItemList,
    ClientName,
    // OrderActions,
    // OrderStatus,
    DeliveryDriver,
    PreorderStatusBar,
    AcceptTimeControls,
  },
};
</script>

<style scoped>
/*
    General Styles
    ============================
*/

.preorder-card-actions {
  display: flex;
  justify-content: space-between;
  margin: 3.7vh 5.4vw 0;
}

.bg-preorder {
  background: #ffd2a8;
  color: #1d1d1d;
}

.w-80 {
  width: 80%;
}

.address {
  padding-left: 2vh;
  margin: 0;
  width: 100%;
  text-align: right;
}
 

p.order-info {
  line-height: 0.8;
  margin-bottom: 0;
  display: inline-block;
}

.client-confirmed-preorder {
  color: #ffd2a8;
}

.client-confirmed-delivery {
  color: #1d1d1b;
  background: #ededed;
}

.client-editing-preorder {
  color: #ffd2a8;
  background: #1d1d1b;
}

.client-serving-preorder {
  color: #ffd2a8;
  background: #1d1d1b;
}

.client-serving-delivery {
  color: #1d1d1b;
  background: #cbd9e6;
}

.client-unpaid-preorder {
  color: #ffd2a8;
  background: #1d1d1b;
}

.client-unpaid-delivery {
  color: #1d1d1b;
  background: #cbd9e6;
}

.client-closed-preorder {
  color: #ffd2a8;
  background: #1d1d1b;
}

.client-closed-delivery {
  color: #1d1d1b;
  background: #cbd9e6;
}

.comment {
  padding: 0 5.4vw;
  margin-top: 2.5vh;
}

.comment h6 {
  font-weight: 500;
  font-size: 5vw;
  margin-bottom: 0;
}

.comment p {
  padding: 1.3vh 4vw 0;
  margin-bottom: 0;
  font-size: 4.5vw;
}

/*
    Card Headers
    ===============
    
    These classes apply dynamically to the card header,
    depending on the preorder status
*/

.header-confirmed-delivery {
  background-color: #cbd9e6;
  color: #1d1d1b;
  border-radius: 2.5vh 2.5vh 0 0;
}

.header-confirmed-preorder {
  background-color: #ffd2a8;
  color: #1d1d1b;
  border-radius: 2.5vh 2.5vh 0 0;
}

.header-editing-preorder {
  background-color: #ffd2a8;
  color: #1d1d1b;
  border-radius: 2.5vh 2.5vh 0 0;
}

.header-creating-preorder {
  background-color: #ffd2a8;
  color: #1d1d1b;
  border-radius: 2.5vh 2.5vh 0 0;
}

.header-serving-delivery {
  background-color: #cbd9e6;
  color: #1d1d1b;
  border-radius: 2.5vh 2.5vh 0 0;
}

.header-serving-preorder {
  background-color: #ffd2a8;
  color: #1d1d1b;
  border-radius: 2.5vh 2.5vh 0 0;
}

.header-unpaid-delivery {
  background-color: #cbd9e6;
  color: #1d1d1b;
  /* background-color: #1d1d1b;
  color: #ededed; */
  border-radius: 2.5vh 2.5vh 0 0;
}

.header-unpaid-preorder {
  background-color: #ffd2a8;
  color: #1d1d1b;
  /* background-color: #1d1d1b;
  color: #ededed; */
  border-radius: 2.5vh 2.5vh 0 0;
}

.header-closed-delivery {
  background-color: #129b81;
  color: white;
  border-radius: 2.5vh 2.5vh 0 0;
}

.header-closed-preorder {
  background-color: #129b81;
  color: white;
  border-radius: 2.5vh 2.5vh 0 0;
}

.header-cancelled-preorder,
.header-cancelled-delivery {
  background-color: #e2223b;
  color: #ededed;
  border-radius: 2.5vh 2.5vh 0 0;
}

.header-closed-preorder .client-name {
  color: white !important;
}

.total-block {
  line-height: 0.8;
  padding: 0 5.4vw;
  margin-top: 2.5vh;
}

.total {
  display: inline-block;
  margin: 0 !important;
  font-size: 6.5vw;
  text-align: initial;
  padding-top: 0.9vh;
  line-height: 0.8;
}

span.amount {
  float: right;
  margin-top: 0vh;
  line-height: 0.8;
  font-size: 9.6vw;
  font-weight: 500;
}

.choose-delivery-time {
  margin-top: 2.5vh;

  padding-left: 5vw;
  padding-right: 5vw;
}

.delivery-time-buttons {
  display: flex;
  justify-content: space-between;

  margin-top: 2vh;
}

.delivery-time-badge {
  color: #1d1d1b;
  border: 2px solid #129b81;
  padding: 1.5vh 2.5vh;
  border-radius: 5vh;
  margin-right: 1vw;
}

.delivery-time-badge-active {
  background: #129b81;
  color: #ededed;
  transition: 0.3s;
}

.delivery-time-input {
  margin-top: 1.9vh;
  outline: none;
  border: 2px solid #129b81;
  border-radius: 10vw;
  width: 100%;
  background: transparent;

  padding: 14px 24px 14px 24px;
  text-align: center;
  text-align-last: center;

  -webkit-appearance: none;
}

.car-time-badge {
  border: 2px solid #416293;
}

.serving-timer {
  color: #129b81;
}

.serving-timer-red {
  color: #e2223b;
}

.choose-car-time {
  margin-top: 5vh;

  padding-left: 5vw;
  padding-right: 5vw;
}

.car-time-buttons {
  display: flex;
  justify-content: space-between;

  margin-top: 2vh;
}

.car-time-badge-active {
  background: #416293;
  color: #ededed;
  transition: 0.3s;
}

.card-no-buttons {
  border-radius: 2.5vh !important;
}

.pay-method {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 5.4vw;
  margin-bottom: 2vh;
  font-weight: 500;
  font-size: 5vw;
  margin-top: 1vh;
}

.pay-method-first {
  margin-top: 2.4vh;
}

img.del {
  height: 2.5vh;
  width: auto;
  vertical-align: text-top;
}

@media (min-width: 768px) {
  .address {
    font-size: 1.7vh;
  }
  
  .order-id {
    padding: 1.736vw 1.389vw 1.389vw;
  }
  .order-id h3 {
    font-size: 2.083vw;
    line-height: 2.431vw;
  }
  .order-id span {
    padding: 0;
    right: 0;
    top: 0;
    font-size: 1.042vw;
    line-height: 1.181vw;
  }
  .order-id span h3 {
    font-size: 2.083vw;
    line-height: 2.431vw;
  }

  .order-details {
    padding: 1.389vw 1.389vw 0;
  }
  .order-details div {
    padding: 0;
    margin-right: 0;
    margin-bottom: 1.389vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
  }

  .order-details div div:last-child {
    margin-bottom: 0;
  }

  .order-details div img {
    width: 1.25vw;
    height: 1.25vw;
  }
  .header img {
    margin-right: 0.7777vh;
  }
  p.order-info {
    font-size: 1.111vw;
  }
  .order-details .float-right {
    font-size: 1.111vw;
  }
  .total-block {
    padding: 0 2.2222vh;
    margin-top: 2.22vh;
  }
  .total {
    padding: 0;
    font-size: 1.667vw;
    line-height: 1.944vw;
  }
  span.amount {
    font-size: 2.5vw;
    line-height: 2.847vw;
  }
  .pay-method-first,
  .pay-method,
  .choose-delivery-time {
    margin-top: 2.22vh;
    padding: 0 2.2222vh;
  }
  .pay-method {
    font-size: 2.2222vh;
  }
  .delivery-time-badge {
    margin-right: 0;
    font-size: 1.7777vh;
    padding: 1.5vh;
    cursor: pointer;
  }
  .preorder-card-actions {
    margin: 3.333vh 2.2222vh 0;
  }
  .comment {
    padding: 0 2.2222vh;
  }
  .comment h6 {
    font-size: 2.5vh;
  }
  .comment p {
    padding: 1.1111vh;
    font-size: 1.777vh;
  }
  .choose-delivery-time h5 {
    font-size: 2.777vh;
  }
  .delivery-time-buttons div {
    width: auto;
    text-align: center;
  }
  .delivery-time-input {
    font-size: 2.2222vh;
  }
  .total-block {
    padding: 1.389vw;
    margin: 0;
  }
  h4.total {
    font-size: 1.667vw;
    line-height: 1.944vw;
  }
  span.amount {
    font-size: 2.5vw;
    line-height: 0.7;
  }
  .comment {
    padding: 1.389vw 1.389vw 0 1.389vw;
    margin: 0;
  }
  .comment h6 {
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  .comment p {
    padding: 0.694vw;
    font-size: 0.903vw;
    line-height: 1.042vw;
  }
  .choose-delivery-time {
    padding: 1.389vw;
    margin: 0;
  }
  .choose-delivery-time h5,
  .choose-car-time h5 {
    font-size: 1.25vw;
    line-height: 1.458vw;
    color: #908f8d;
  }
  .delivery-time-buttons .delivery-time-badge,
  .car-time-buttons .car-time-badge {
    width: 6.111vw;
    height: 3.472vw;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1.042vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
  }
  .delivery-time-input {
    width: 20.486vw;
    height: 3.403vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
  }
  small.info {
    font-size: 0.903vw;
    line-height: 1.042vw;
    padding: 1.389vw 1.389vw 0.694vw;
  }
  div.preorder-card-actions {
    padding: 1.389vw 1.389vw 0 1.389vw;
    margin: 0;
  }
  .choose-car-time {
    margin: 0;
    padding: 1.389vw;
  }
  .order-actions-box {
    padding: 1.389vw;
    margin: 0 !important;
  }
   
}
.d-flex {
  width: 100%;
}

/* .client-unpaid {
  color: #1d1d1b !important;
  background: #ededed !important;
} */

.preorder-serving-cancel {
  width: 100%;
  padding: 1.4vh 4.2vw;
  border-radius: 5vh;
  font-size: 1.77vh;
  border: 0;
  font-weight: 500;
  color: white;
  outline: none;
  -webkit-appearance: none;
  background: transparent;
  border: 1px solid #e2223b;
  color: #e2223b;
}

.takeaway-order-info {
  width: 63%;
}

/* .takeaway-icon {
  margin-top: -2vh !important;
} */

.phone-link {
  text-decoration: none;
}
p.float-right {
  margin-bottom: 0;
}

.client-phone-value {
  text-decoration: underline;
}
</style>
